import React, { useEffect, useState } from "react";
import Page from "./page";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { actionRefreshTablePerfil, actionOpenEditPerfil } from "../actionsPerfiles";
import * as yup from 'yup'
import { updatePerfil } from "../requestPerfiles";
import { useSnackbar } from 'notistack';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

export default function EditarPerfil() {

  const dispatch = useDispatch();
  const notistack = useSnackbar();
  const { open, perfil } = useSelector((state) => ({
    open: state.reducerPerfil.openEditPerfil,
    perfil: state.reducerPerfil.perfilSeleccionado
  }));

  const validationSchema = yup.object({
    nombre: yup.string().required("Campo requerido"),
    descripcion: yup.string().required("Campo requerido"),
  });

  const formik = useFormik({
    initialValues: {
      nombre: "",
      descripcion: ""
    },
    onSubmit: values => {
      const key = notistack.enqueueSnackbar("Guardando cambios...", {
        persist: true,
        anchorOrigin: {
          horizontal: "center",
          vertical: "bottom"
        }
      });
      try {
        updatePerfil(perfil._id, values)
          .then((response) => {
            if (response.status === 200) {
              notistack.closeSnackbar(key);
              const successkey = notistack.enqueueSnackbar("Operanción exitosa: Cambios guardados", {
                variant: 'success',
                anchorOrigin: {
                  horizontal: "center",
                  vertical: "bottom"
                },
                action: <IconButton onClick={() => notistack.closeSnackbar(successkey)}><Close /></IconButton>
              });
              dispatch(actionOpenEditPerfil());
              dispatch(actionRefreshTablePerfil(true));
            } else {
              console.log(response);
              notistack.closeSnackbar(key);
              const errorkey = notistack.enqueueSnackbar("Error: No ha sido posible actualizar el Perfil. Intente nuevamente o contacte con soporte el equipo de soporte", {
                variant: 'error',
                anchorOrigin: {
                  horizontal: "center",
                  vertical: "bottom"
                },
                action: <IconButton onClick={() => notistack.closeSnackbar(errorkey)}><Close /></IconButton>
              });
            }
          })
          .catch((e) => {
            console.log(e);
            notistack.closeSnackbar(key);
            const errorkey = notistack.enqueueSnackbar("Error: No ha sido posible actualizar el Perfil. Contacte con soporte el equipo de soporte", {
              variant: 'error',
              anchorOrigin: {
                horizontal: "center",
                vertical: "bottom"
              },
              action: <IconButton onClick={() => notistack.closeSnackbar(errorkey)}><Close /></IconButton>
            });
          });

      }
      catch (e) {
        console.log(e);
        notistack.closeSnackbar(key);
        const errorkey = notistack.enqueueSnackbar("Error: No ha sido posible actualizar el Perfil Contacte con soporte el equipo de soporte", {
          variant: 'error',
          anchorOrigin: {
            horizontal: "center",
            vertical: "bottom"
          },
          action: <IconButton onClick={() => notistack.closeSnackbar(errorkey)}><Close /></IconButton>
        });
      }
    },
    validationSchema: validationSchema,
  });

  const onClose = () => dispatch(actionOpenEditPerfil());

  const onEntered = () => {
    console.log(perfil);
    formik.resetForm({
      values: {
        nombre: perfil.nombre,
        descripcion: perfil.descripcion
      }
    });
  }

  return (
    <Page
      formik={formik}
      onClose={onClose}
      onEntered={onEntered}
      open={open}
    />
  );
}